import { API_BASE_URL } from '..'

export interface FetchResponse<T> {
  status: number
  statusText: string
  body: T
  headers: any
  ok: boolean
}

export interface ApiFetchConfig {
  endpoint: string
  method: string
  accessToken?: string
  body?: any
  headers?: any
  //un-encoded uri paramters that gets appended to the url
  params?: {key: string, value: string}[]
}

export async function apiFetch<T>(config: ApiFetchConfig): Promise<FetchResponse<T>> {
  const url = `${API_BASE_URL}/${config.endpoint}`
  config.headers = {
    ...config.headers,
    'Authorization': `Bearer ${config.accessToken}`
  }

  let parameters = config.params
  let params = ''
  if(parameters){
    params = `?${parameters.map(p => `${encodeURIComponent(p.key)}=${encodeURIComponent(p.value)}`).join('&')}`
  }

  const response = await fetch(`${url}${params}`, {
    body: config.body,
    headers: config.headers,
    method: config.method
  })

  let returnBody = await response.text()
  try{
    returnBody = JSON.parse(returnBody)
  }catch(error){
    // return body is not json
  }

  return {
    body: returnBody as T,
    headers: response.headers,
    status: response.status,
    statusText: response.statusText,
    ok: response.ok
  }
}

export async function apiFetchBody<T>(config: ApiFetchConfig): Promise<T> {
  const response = await apiFetch<T>(config)
  return response.body
}
